import React from 'react';

function Redo({ size, ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...otherProps}
    >
      <path d="M7.74900649,20.2238613 C4.89221724,17.4490946 4.31916961,14.3675143 6.02986358,10.9791203 C7.36373929,8.33709529 9.18688246,7.50037809 12.0263273,7.06794071 C13.8752878,6.78635058 16.0805838,7.21320693 18.6422153,8.34850976" />
      <polyline points="13.7583286 11.5236143 19.0925375 8.22899122 15.728997 2.9235519" />
    </svg>
  );
}

export default Redo;
